import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Button } from 'react-bootstrap';
import { reduce } from 'lodash';
import { getUser, getUserCurrentOrganization } from '../Auth/AuthReducer';
import Pusher from '../../components/pusher';
import { startSyncingOrganization, endSyncingOrganization } from '../Setup/SetupActions';
import {
  loginFromCookieRequest, fetchUserInfo,
  fetchCollectorLanguageMappings,
  showCollectorLanguageMappingModal,
} from '../Auth/AuthActions';
import { updateNotifications } from '../News/NewsActions';


class PusherReceiver extends Component {
  constructor(props) {
    super(props);
    this.state = {
      notifyVersion: typeof window !== 'undefined' ? window.APP_VERSION : null,
    };

    this.handleVersionChange = this.handleVersionChange.bind(this);
    this.handleMaintenanceModeChange = this.handleMaintenanceModeChange.bind(this);
    this.handleAppAnnouncements = this.handleAppAnnouncements.bind(this);
    this.handleOrganizationUpdate = this.handleOrganizationUpdate.bind(this);

    this.handleSyncingOrganization = this.handleSyncingOrganization.bind(this);
    this.handleSyncingOrganizationSuccess = this.handleSyncingOrganizationSuccess.bind(this);
    this.handleSyncingOrganizationErrors = this.handleSyncingOrganizationErrors.bind(this);
    this.handleSyncingOrganizationProgressError = this.handleSyncingOrganizationProgressError.bind(this);
    this.adminHanldeSyncingOrganizationError = this.adminHanldeSyncingOrganizationError.bind(this);
    this.adminHandleSyncingOrganizationSuccess = this.adminHandleSyncingOrganizationSuccess.bind(this);
    this.checkCollectorMappingUpdate = this.checkCollectorMappingUpdate.bind(this);
    this.handleUserConnected = this.handleUserConnected.bind(this);
  }

  componentDidMount() {
    const { user } = this.props;
    if (user._id) {
      this.handleAppAnnouncements(); // init
    }
  }

  handleMaintenanceModeChange(isOn) {
    if (isOn && typeof window !== 'undefined') {
      window.location.replace('/');
    }
  }


  handleVersionChange(newVersion) {
    const version = process.env.REACT_APP_APP_VERSION;
    const { notifyVersion } = this.state;
    if (notifyVersion === newVersion || newVersion === version) {
      return;
    }
    const title = ((
      <div>
        <p><strong>A New Version of TruVoice Automation&trade; is Available!</strong></p>
        <p>Version {newVersion} is now available.</p>
        <Button
          onClick={() => {
            window.location.reload();
          }}
          bsStyle="primary"
          bsSize="sm"
        >
          Get New Version
        </Button>
      </div>
    ));
    this.addNotification(title, {
      autoClose: false,
      closeOnClick: false,
      type: 'warning',
      onClose: () => {
        this.setState({ notifyVersion: newVersion });
      },
    });
    this.setState({ notifyVersion: newVersion });
  }


  handleOrganizationUpdate() {
    this.props.dispatch(fetchUserInfo());
  }

  checkCollectorMappingUpdate() {
    this.props.dispatch(fetchCollectorLanguageMappings())
      .then(
        (colectors) => {
          const unmappedCollectors = reduce(colectors, (items, item) => {
            if (item.selected_language === undefined) {
              items.push(item);
            }
            return items;
          }, []);
          if (unmappedCollectors.length > 0) {
            this.props.dispatch(showCollectorLanguageMappingModal());
          }
        },
        () => { },
      );
  }

  handleUserConnected(org) {
    this.checkCollectorMappingUpdate(org);
  }

  handleAppAnnouncements() {
    this.props.dispatch(updateNotifications());
  }


  handleSyncingOrganization(org) {
    this.props.dispatch(startSyncingOrganization(org.organization_id));
  }

  handleSyncingOrganizationSuccess(org) {
    this.showSuccessToast(org);
    this.props.dispatch(loginFromCookieRequest());
  }

  handleSyncingOrganizationErrors(org, { message }) {
    this.showErrorToast(org, { message });
    this.props.dispatch(loginFromCookieRequest());
  }

  handleSyncingOrganizationProgressError(org, { message }) {
    this.showErrorToast(org, { message: (message || 'Error Syncing') });
  }

  showErrorToast(org, { message }) {
    const el = (
      <div>
        <div><strong>{org.display_name}</strong></div>
        <div>{(message || 'Refreshing Organization Data Error')}</div>
      </div>
    );
    this.addNotification(el, { type: 'error' });
  }

  showSuccessToast(org) {
    const el = (
      <div>
        <div><strong>{org.display_name}</strong></div>
        <div>Refreshing Organization Data Success</div>
      </div>
    );
    this.addNotification(el, { type: 'success' });
  }

  adminHanldeSyncingOrganizationError(org, { message }) {
    const { userCurrentOrganization } = this.props;
    if (userCurrentOrganization) {
      const currentId = userCurrentOrganization.is_demo ? userCurrentOrganization.target_organization_id : userCurrentOrganization.organization_id;
      if (currentId !== org.organization_id) {
        this.showErrorToast(org, { message });
      }
    }
    this.props.dispatch(endSyncingOrganization(org.organization_id));
  }

  adminHandleSyncingOrganizationSuccess(org) {
    const { userCurrentOrganization } = this.props;
    if (userCurrentOrganization) {
      const currentId = userCurrentOrganization.is_demo ? userCurrentOrganization.target_organization_id : userCurrentOrganization.organization_id;
      if (currentId !== org.organization_id) {
        this.showSuccessToast(org);
      }
    }
    this.props.dispatch(endSyncingOrganization(org.organization_id));
  }

  addNotification(content, config = {}) {
    this.context.addNotification(content, config);
  }

  render() {
    const { userCurrentOrganization, user } = this.props;
    const orgId = userCurrentOrganization ? userCurrentOrganization._id : null;
    const isAdmin = user && (user.role === 'superadmin' || user.role === 'admin');
    return (
      <div>
        <Pusher event="appVersion" handler={this.handleVersionChange} />
        <Pusher event="maintenanceMode" handler={this.handleMaintenanceModeChange} />
        <Pusher event="appAnnouncements" handler={this.handleAppAnnouncements} />

        <Pusher event="test-socket" handler={(p) => {
          console.clear();
          console.log(p)
        }} />

        <Pusher event="test-socket-2" handler={(...args) => {
          console.clear();
          console.log(...args);
        }} />


        {orgId !== null &&
          <div>
            {user !== null && <Pusher key={user._id} event="userConnected" handler={this.handleUserConnected} />}
            <Pusher key={`${orgId}-organizationUpdate`} event="organizationUpdate" handler={this.handleOrganizationUpdate} />
            <Pusher key={`${orgId}-organizationCollectorMappingUpdate`} event="organizationCollectorUpdate" handler={this.checkCollectorMappingUpdate} />
            <Pusher key={`${orgId}-syncingOrganization`} event="syncingOrganization" handler={this.handleSyncingOrganization} />
            <Pusher key={`${orgId}-syncingOrganizationSuccess`} event="syncingOrganizationSuccess" handler={this.handleSyncingOrganizationSuccess} />
            <Pusher key={`${orgId}-syncingOrganizationError`} event="syncingOrganizationError" handler={this.handleSyncingOrganizationErrors} />
            <Pusher key={`${orgId}-syncingOrganizationProgressError`} event="syncingOrganizationProgressError" handler={this.handleSyncingOrganizationProgressError} />
            {isAdmin && <Pusher key={`${orgId}-adminSyncingOrganizationError`} event="adminSyncingOrganizationError" handler={this.adminHanldeSyncingOrganizationError} />}
            {isAdmin && <Pusher key={`${orgId}-adminSyncingOrganizationSuccess`} event="adminSyncingOrganizationSuccess" handler={this.adminHandleSyncingOrganizationSuccess} />}

          </div>
        }
      </div>
    );
  }
}

PusherReceiver.propTypes = {
  dispatch: PropTypes.func.isRequired,
  user: PropTypes.shape({
    user_id: PropTypes.string,
  }).isRequired,
  userCurrentOrganization: PropTypes.shape({}),
};
PusherReceiver.defaultProps = {
  userCurrentOrganization: null,
};

PusherReceiver.contextTypes = {
  addNotification: PropTypes.func.isRequired,
};

// Retrieve data from store as props
function mapStateToProps(state) {
  return {
    user: getUser(state),
    userCurrentOrganization: getUserCurrentOrganization(state),
  };
}

export default connect(mapStateToProps)(PusherReceiver);
